import React from 'react';
import { TripMatch, Review, SalesRecording } from '@marageti/z4-sdk/lib/travel';
import { Stack } from '@mui/material';
import BookingDetails from '../booking-details/booking-details-view';
import ReviewPrompt from './review-prompt';
import ReviewCard from './review-card';
import { TripType } from '../booking-details/types';

const TripMatchDetails = ({
  isLoading,
  tripMatch,
  reviews,
  reviewPrompt,
  salesRecordings,
  hideDetails,
}:{
  isLoading: boolean,
  tripMatch: TripMatch,
  reviews: Review[] | undefined,
  reviewPrompt: {
    show: boolean,
    emptyReview: Review | undefined,
  }
  salesRecordings: SalesRecording[] | undefined,
  hideDetails: boolean,
}) => (
  <Stack spacing={2}>
    <BookingDetails
      tripType={TripType.TripMatch}
      isLoading={isLoading}
      partnerName={tripMatch.partnerName}
      departureDate={tripMatch.departureDate}
      returnDate={tripMatch.returnDate}
      numAdults={tripMatch.numberOfAdults}
      numChildren={tripMatch.numberOfChildren}
      countries={tripMatch.countries}
      tripBudget={tripMatch.budget}
      description=""
      salesRecordings={salesRecordings}
      hideDetails={hideDetails}
    />

    {reviewPrompt.show && (
      <ReviewPrompt tripMatch={tripMatch} reviewPrompt={reviewPrompt} />
    )}

    {reviews && reviews.map((review) => (
      <ReviewCard key={review.id} review={review} />
    ))}
  </Stack>
);

export default TripMatchDetails;
